module.exports = function (file) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'views';
  return function () {
    return import('@/' + base + file + '.vue');
  };
};


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/router/_import_production.js
// module id = ltUh
// module chunks = 115